import { useNavigate, useLocation, useParams } from 'react-router-dom'

const UserPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams()
  const { acc_id } = params  // Access the user_id parameter

  return (
    <div>
      <h1>User Profile</h1>
      <p>Displaying information for user: {acc_id}</p>
    </div>
  )
}

export default UserPage
